import React from 'react'
import exact from 'prop-types-exact'
import PropTypes from 'prop-types'
import { IonChip, IonLabel } from '@ionic/react'
import { ORDER_STATUS } from 'types'

// Pseudo-statuses the manager API emits as list labels in place of a real
// WorkOrder#status. Kept local to StatusTile (rather than in ORDER_STATUS)
// because they aren't actual order states.
const PM_AWAITING_ACCEPT_DECLINE = 'Awaiting Accept/Decline (PM)'

const propTypes = {
  status: PropTypes.string,
}

const defaultProps = {}

// Status tile for WorkOrders and Trips
function StatusTile({ status }) {
  if (!status) return <></>

  const getColor = (status) => {
    switch (status) {
      case ORDER_STATUS.TECH_ON_SITE:
        return 'tss-orange'
      case ORDER_STATUS.AWAITING_PARTS:
        return 'tss-red'
      case ORDER_STATUS.ESTIMATE:
        return 'tss-blue'
      case ORDER_STATUS.SCHEDULED:
        return 'tss-pink'
      case ORDER_STATUS.WORK_COMPLETED:
        return 'tss-green'
      case ORDER_STATUS.ASSIGNED:
      case PM_AWAITING_ACCEPT_DECLINE:
        return 'tss-orange'
      default:
        return 'tss-red'
    }
  }

  return (
    <IonChip color={getColor(status)}>
      <IonLabel>{status}</IonLabel>
    </IonChip>
  )
}

StatusTile.propTypes = exact(propTypes)
StatusTile.defaultProps = defaultProps

export default StatusTile
